<aslib-grid #grid id="grid" name="grid" headerTitle="Dados para pagamento" [(dataset)]="listaNaoProcessado"
  indexColumnVisible="true" limit="10">
  <aslib-grid-column [property]="'id'" [visible]="false" header="id" class="text-right" [width]="1" [sortable]="true"
    [resizable]="true"></aslib-grid-column>
  <aslib-grid-column [property]="'cnpjCpfCredor'" header="CPF/CNPJ do Credor" class="text-right" [width]="200"
    [sortable]="false" [resizable]="true">
    <ng-template #AslibGridCell let-item="item">
      <span>{{item.cnpjCpfCredor | cpf}}</span>
    </ng-template>
  </aslib-grid-column>
  <aslib-grid-column [property]="'nomeCredor'" header="Nome do Credor" class="text-left" [sortable]="true"
    [resizable]="true"></aslib-grid-column>
  <aslib-grid-column [property]="'numeroProcessoSEI'" header="Número do Processo SEI" class="text-left" [width]="220"
    [sortable]="true" [resizable]="true">
    <ng-template #AslibGridCell let-item="item">
      <span>{{item.numeroProcessoSEI | processoSei}}</span>
    </ng-template>
  </aslib-grid-column>
  <aslib-grid-column [property]="'valorPedido'" header="Valor" class="text-right" [width]="175" [sortable]="true"
    [resizable]="true">
    <ng-template #AslibGridCell let-item="item">
      <span>{{item.valorPedido | currency:'BRL'}}</span>
    </ng-template>
  </aslib-grid-column>
  <aslib-grid-column [property]="'mensagemErro'" header="Erro" class="text-left" [width]="300" [sortable]="true"
    [resizable]="true"></aslib-grid-column>
</aslib-grid>
<br>



// WEBPACK FOOTER //
// ./src/app/pagamento/empenho/nao-processado/nao-processado.component.html